import React, { Fragment } from 'react';

import * as Actions from 'notifications_historic/components/list/actions';

const NotificationsHistoricActions = ({
  permissions,
  notificationHistoric,
  company,
  subcompany,
  handleToggle,
}) => {
  return (
    <Fragment>
      {permissions['acl.users.toggle'] && ( // acl.notification_historic.toggle
        <Actions.Email notificationHistoric={notificationHistoric} handleClick={handleToggle} />
      )}
      {/* {permissions["acl.users.update"] && ( // acl.notification_historic.update
        <Actions.Edit notificationHistoric={notificationHistoric} company={company} subcompany={subcompany} />
      )} */}
    </Fragment>
  );
};

export default NotificationsHistoricActions;



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_historic/components/list/NotificationsHistoricActions.js